import { inject } from '@angular/core';
import { hasAccessGuard } from '../app/guards/permission-guard';
import { DownloadCenterAccessService } from './services/download-center-access.service';

/**
 * Route guard for the Download Center: the `navigate` answer from the backend,
 * evaluated in the Operating Company's CUSTOMER default organization.
 *
 * Replaces `hasPermissionGuard('PURE1:navigate:download_center')`, whose bare
 * `isAllowed` resolves against the effective organization — on this OC-level
 * page, whichever org was last visited (see {@link DownloadCenterAccessService}).
 * The login check and the best-available-page redirect are `hasPermissionGuard`'s own.
 */
export const downloadCenterAccessGuard = hasAccessGuard(() => inject(DownloadCenterAccessService).navigate$);
